<template>
  <div
    class="tbe-main-view"
    :class="[`tbe-main-view--layout--${appearanceSettings.design.layout}`]"
  >
    <div class="tbe-main-view__block tbe-main-view__block--product">
      <tbe-product />
    </div>

    <div class="tbe-main-view__block tbe-main-view__block--check-availability">
      <tbe-number-people />
      <tbe-calendar />
      <tbe-button
        class="check-availability-btn"
        variant="primary"
        @click="checkAvailabilityClickHandler"
        :loading="!checkAvailabilitySubmitted && checkAvailabilityLoading"
        :disabled="checkAvailabilitySubmitted"
      >
        Check Availability
      </tbe-button>
    </div>

    <div
      class="tbe-main-view__block tbe-main-view__block--options"
      :style="{ minHeight: options.length === 0 && checkAvailabilityLoading ? '300px' : 'auto' }"
    >
      <tbe-loading
        v-model:active="checkAvailabilityLoading"
        :is-full-page="false"
        color="#1976d2"
        :opacity="0.6"
        transition="tbe-loader-fade"
      >
        <tbe-ball-grid-pulse />
      </tbe-loading>

      <Transition>
        <tbe-options v-if="options.length" />
      </Transition>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  import tbeLoading from 'vue-loading-overlay'

  import tbeOptions from '@/components/tbeOptions'
  import tbeNumberPeople from '@/components/tbeNumberPeople'
  import tbeProduct from '@/components/tbeProduct'
  import tbeCalendar from '@/components/tbeCalendar'
  import { RsButton as tbeButton, loaders } from 'common/components'

  import 'v-calendar/dist/style.css'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'tbeMainView',

    components: {
      tbeLoading,
      tbeOptions,
      tbeNumberPeople,
      tbeProduct,
      tbeCalendar,
      tbeButton,
      tbeBallGridPulse: loaders.RsBallGridPulse
    },

    setup() {
      const store = useStore()

      const appearanceSettings = computed(() => store.state.app.appearanceSettings)
      const options = computed(() => store.state.booking.options)

      const checkAvailabilityLoading = computed(() => store.state.booking.checkAvailabilityLoading)
      const checkAvailabilitySubmitted = computed(
        () => store.state.booking.checkAvailabilitySubmitted
      )
      const checkAvailability = (payload) => store.dispatch('booking/checkAvailability', payload)

      const checkAvailabilityClickHandler = () => checkAvailability()

      return {
        appearanceSettings,
        options,
        checkAvailabilityLoading,
        checkAvailabilitySubmitted,
        checkAvailabilityClickHandler
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-main-view {
    display: grid;
    gap: 20px;

    &__block {
      &--check-availability {
        display: grid;
        gap: 20px;
      }

      &--options {
        position: relative;
      }
    }

    &--layout {
      &--row {
        .tbe-main-view {
          &__block {
            &--check-availability {
              grid-template-columns: repeat(3, 1fr);

              @media screen and (max-width: 768px) {
                grid-template-columns: 100%;
              }
            }
          }
        }
      }

      &--column {
        .tbe-main-view {
          &__block {
            &--check-availability {
              grid-template-columns: 100%;
            }
          }
        }
      }
    }
  }

  .check-availability-btn {
    align-self: flex-end;
    height: 40px;
  }

  .tbe-loader-fade-enter-active,
  .tbe-loader-fade-leave-active {
    transition: opacity 0.25s;
  }

  .tbe-loader-fade-enter,
  .tbe-loader-fade-leave-to {
    opacity: 0;
  }
</style>
